import React, { useEffect, useState } from "react";

import { Box, Stack } from '@mui/system'
import { Typography } from '@mui/material'
import { Link } from "react-router-dom";
import HomeOutlined from '@mui/icons-material/HomeOutlined'
import HomeIcon from '@mui/icons-material/Home';
import AppShortcutOutlinedIcon from '@mui/icons-material/AppShortcutOutlined';
import AppShortcutIcon from '@mui/icons-material/AppShortcut';
import { useNavigate } from "react-router-dom";
import { Sidebar } from './';


const boxSx = {
    borderRadius:"10px",
    "cursor":"pointer",
    "&:hover":{
        backgroundColor:"#A0A0A0",
        
    }

}


    
    

function Side({selectedCategory,setSelectedCategory,menuIcon,sidebar,setSidebar}) {
    // const [selectedCategory, setSelectedCategory] = useState("Home");
    const navigate = useNavigate();
    const onhandleSubmit = (e,category) => {
        e.preventDefault();
        // console.log(category)
        setSelectedCategory(category)
        if (category==="Home"){
            navigate(`/`);
        }else{
            navigate(`/${category}`);
        }
        
    };

    useEffect(()=>{
        setSelectedCategory("Home")
    },[])

      

  return (
    <Stack>
        <Sidebar selectedCategory={selectedCategory}setSelectedCategory={setSelectedCategory} menuIcon={menuIcon} sidebar={sidebar} setSidebar = {setSidebar}/>
            <Stack position="sticky" alignItems="center" justifyContent="center" gap="20px">
                
                    <Box onClick = {(e) => onhandleSubmit(e,"Home")}
                        
                        borderRadius="10px" sx={boxSx}>
                        <Stack  alignItems="center" justifyContent="center">
                       { (selectedCategory==="Home")?
                            <HomeIcon style={{width:"30px", height:"43px", color: "white" ,justifyContent: "center"}}/>:
                            <HomeOutlined style={{width:"30px", height:"43px", color: "white" ,justifyContent: "center"}}/>


                       }
                                <Typography align = "center" color = "white"   sx={{ fontSize: "15px" ,fontWeight:"bold"}}>
                                    Home
                                </Typography>
                            
                        </Stack>
                    </Box>

                

                
                    <Box  borderRadius="10px" sx={boxSx} onClick = {(e) => onhandleSubmit(e,"Shorts")}>
                        

                        <Stack alignItems="center" justifyContent="center">
                        { (selectedCategory && selectedCategory==="Shorts")?
                            <AppShortcutIcon style={{cursor:"pointer", width:"30px", height:"43px", color: "white" ,justifyContent: "center"}}/>:
                            <AppShortcutOutlinedIcon style={{cursor:"pointer", width:"30px", height:"43px", color: "white" ,justifyContent: "center"}}/>

                    }
                            <Typography align = "center" color = "white"   sx={{ fontSize: "15px" ,fontWeight:"bold"}}>
                                Shorts
                            </Typography>
                        </Stack>
                    </Box>

                
                
                
                

                

            </Stack>
            

        

    </Stack>

    
    
  )
}

export default Side